import React from 'react';
import GamesDetails from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails';

export default function PcGamesDetails(props: any) {
  return (
    <>
      <GamesDetails
        {...props}
        entityType={'pc'}
        moduleName={'pcGames'}
      />
    </>
  );
}

